<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">

      <div class="form_wrap">
        <div class="toolsIntroduce">
          <div class="left">
            <img src="../img/face.png" alt="">
          </div>
          <div class="right">
            <p>
              Viggle专业版说明
            </p>
            <span style="display: block">
             根据视频锁定骨骼动作，将图片转换成一致性的角色动画，提供更有趣的玩法
            </span>
          </div>
        </div>
        <div class="options_item" >
          <div class="item_title" flex-align>
            <div class="text">上传人物图片</div>
          </div>
          <div class="Reference_image">
            <el-upload :http-request="$projectUpload"
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/aivideo/upload/?soft=3&fdir=viggle&key=sdf232fsdfa@3#@!'"
                :show-file-list="false"
                accept=".jpg,.png"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                multiple>
              <div v-if="create_form.img_url" class="yesUpload">
                <img :src="create_form.img_url" alt="" class="yesUpload_img">
                <div class="yesUpload_icon" @click.stop="create_form.img_url=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过10MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="No_img">
          <p>
            没有人物图片？试试以下图片
          </p>
          <div class="img_list">
            <img v-for="img_url in img_list"
                 :src="cdn_url_replace(img_url)"
                 alt=""
                 @click="create_form.img_url = img_url "
            >
          </div>
        </div>
        <div class="options_item" >
          <div class="item_title" flex-align>
            <div class="text">上传人物视频</div>
          </div>
          <div class="Reference_video" :style="create_form.video_url != ''?'height:auto;':'height:140px;'">
            <el-upload :http-request="$projectUpload"
                :style="create_form.video_url != ''?'height:auto;':'height:140px;'"
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/aivideo/upload/?soft=3&fdir=viggle&key=sdf232fsdfa@3#@!'"
                :show-file-list="false"
                :accept="'video/*'"
                :on-success="handleAvatarSuccessVideo"
                :before-upload="beforeAvatarUploadVideo"
                multiple>
              <div v-if="create_form.video_url" class="yesUpload">
                <div class="yesUpload_img">
                  <video playsinline="playsinline"
                         role="application" controls preload
                         style="width: 200px;height: 270px"
                         :src="cdn_url_replace(create_form.video_url)"></video>
                </div>
                <div class="yesUpload_icon" @click.stop="create_form.video_url=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0;width: 100%"> 将视频拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传MP4文件，且不超过100MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="No_img">
          <p>
            没有人物视频？试试以下视频
          </p>
          <div class="img_list">
            <img v-for="(src,index) in cankao_img_list"
                 :src="cdn_url_replace(src)"
                 alt=""
                 @click="clickImgList(src,index)"
            >
          </div>
<!--          <div class="img_list">-->
<!--            <video v-for="(src,index) in cankao_img_list"-->
<!--                   :poster="require('./img/img_0'+(index+1)+'.jpg')"-->
<!--                   width="22%"-->
<!--                   :src="src"-->
<!--                   @click=" clickImgList(src,index) "-->
<!--            ></video>-->
<!--          </div>-->
        </div>
      <div class="options_item" >
          <div class="item_title" flex-align>
            <div class="text">上传人物视频</div>
          </div>
          <div class="Generate_Background">
    <div v-for="item in Background_list"
         :class="item.id==create_form.bgMode?'background_item':''"
         @click="create_form.bgMode = item.id">
      {{ item.name }}
    </div>
  </div>
      </div>
      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button"
            @click="sendMsg" v-loading="sending">
        提交任务
        <span class="fz12">（消耗{{jifen}}积分）</span>
      </div>
<!--      <div class="primary_button" v-loading="sending" style="background-color:#393b3f;color: #999;">-->
<!--        接口维护-->
<!--        <span class="fz12">（预计2-3天）</span>-->
<!--      </div>-->
    </div>
    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import AliCdn from '../../utils/ali_cdn'
import utils from '@/utils/index.js'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      create_form: {
        img_url: "",
        bgMode: 2,// bgMode 1是绿布 0是白色背景 3是视频背景
        modelInfoID: 2, //modelInfoID 2为 v2版本 3是v2超级版本
        watermark: 0, //watermark 1为无水印 0为有水印
        video_url: ""
      },
      sending: false,
      jifen:25,
      fileApi: FILE_API_SERVER,
      frame: false,
      fileAPI: API_SERVER,
      imgDialogVisible: false,
      model_desc: '',

      noMore: false,
      loading: false,
      page: 1,
      intervalId: null,

      select_rec_img: {
        img_url: ''
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      success_icon: true,
      img_list: [
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/11.webp',
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/21.webp',
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/31.webp',
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/41.webp'
      ],
      cankao_img_list: [
        require('./img/1.webp'),
        require('./img/2.webp'),
        require('./img/3.webp'),
        require('./img/4.webp'),
      ],
      cankao_video_list: [
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/1.mp4',
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/2.mp4',
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/3.mp4',
        'https://wenku202404.oss-cn-beijing.aliyuncs.com/aivideo/4.mp4'
      ],
      Background_list: [
  {name: '视频背景', id: 2,},
  {name: '白幕', id: 0,},
  {name: '绿幕', id: 1,},
  //{name: '图片背景', id: 4,},
],

    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    }
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {

  },

  methods: {
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      if (url.indexOf('https://wenku202404.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, {'cdnDomain': 'cdnwenku202404.m.nengshuohuihua.com'})
      }
      return url.replace(o_url, c_url)
    },
    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    //发送消息
    sendMsg() {
      if (!this.checkLogin()) {
        return false
      }
      if(!utils.setOptData(this.userInfo,'btn_viggle_create')){
          return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      if (this.create_form.img_url == '') {
        this.$message.warning('请上传图片！')
        return
      }
      if (this.create_form.video_url == '') {
        this.$message.warning('请上传视频！')
        return
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }


      this.submitQuestion(this.create_form);

    },
    submitQuestion(data, parent_msg_code, i) {
      this.sending = true;
      // 提交问题
      // data.source = "pc";
      this.$http.post('/front/aivideo/viggle/', data).then((res) => {

        if (res.status == 200) {
          this.getProfile()
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box',

            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "expired_gift_score") {
            // 队列已满
            this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          }else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
        return
      }
      if (res.status == '200') {
        this.create_form.img_url = res.data.file_full_url
        this.select_rec_img.img_url = res.data.file_full_url
      }
    },
    beforeAvatarUpload(rawFile) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      const isIMG = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png';
      const isLt10M = rawFile.size / 1024 / 1024 < 10;

      if (!isIMG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return true;
    },
    // 上传视频
    handleAvatarSuccessVideo(res, file) {
      this.create_form.video_url = res.data.file_full_url
    },
    beforeAvatarUploadVideo(file) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      const isMp4 = file.type === 'video/mp4';
      if (!isMp4) {
        this.$message.error('只能上传mp4格式的文件!');
      }
      if (file.size > 100 * 1024 * 1024) {
        this.$message({
          message: '请上传100M以内的视频',
          type: 'warning'
        })
        return false
      }

      // 检查视频时长

      const videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(file);
      const videoURL = URL.createObjectURL(file)
      videoElement.onloadedmetadata = () => {
        const duration = videoElement.duration
        URL.revokeObjectURL(videoURL)
        // 你可以在这里处理视频时长，比如保存到组件数据中
        console.log('视频时长:', duration)
        const basePoints = 25;
        // 每15秒为一个区间
        const interval = 15;
        // 计算完整的15秒区间数量
        const intervals = Math.floor(duration / interval);
        // 计算总积分
        this.jifen = basePoints * (intervals + 1);
        this.jifen > 200 ? this.jifen = 200 : this.jifen
      }
    },
    clickImgList(src, index) {
      this.create_form.video_url = this.cankao_video_list[index]
      if (index == 0||index == 2) {
        this.jifen = 50
      }else if(index == 1||index == 3){
        this.jifen = 75
      }
    },
  },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;
    .left_nav {
      margin: 10px 20px;
      padding: 4px 0;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #36373d;
      display: flex;
      align-items: center;
      color: #fff;
      background-color: #313338;

      div {
        flex: 1;
        text-align: center;
        margin: 0 4px;
        cursor: pointer;
      }

      .navSelected {
        background-color: #5865f2;
        border-radius: 4px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 10px;
      height: 100%;
      .toolsIntroduce {
        background-color: #1e1f22;
        padding: 16px 14px;
        display: flex;
        border-radius: 5px;
        box-sizing: border-box;
        overflow: hidden;

        .left {
          width: 20px;
          margin-right: 12px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .right {
          width: calc(100% - 32px);
          flex-grow: 1;
          word-wrap: break-word;

          p {
            font-size: 14px;
            font-weight: 700;
            height: 20px;
            margin-bottom: 5px;
          }

          span {
            font-size: 12px;
            word-wrap: break-word;
            white-space: normal;
          }

        }
      }

      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }
      // 没有图片or视频
      .No_img {
        width: 100%;
        margin-top: 5px;

        .img_list {
          width: 100%;
          // height: 20px;
          display: flex;
          justify-content: space-between;
          padding-top: 5px;

          img {
            width: 22%;
            // height: 100%;
          }

          img:hover {
            cursor: pointer;
          }

        }

        .video_list {
          width: 100%;
          //height: 20px;
          display: flex;
          justify-content: space-between;
          padding-top: 5px;

          video {
            width: 22%;
          }

          video:hover {
            cursor: pointer;
          }

        }
      }
      // 视频
      .Reference_video {
        width: 100%;
        //height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
          width: 100%;
        }
        /deep/ .el-upload {
        width: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 100%;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 100%;
        }

        .noUpload {
          width: 100%;
          height: 140px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }


        .yesUploadVideo {
          position: relative;

          .yesUpload_video {

            height: 270px;

          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }
        }
        .yesUpload_icon {
          position: absolute;
          right: 8px;
          bottom: 12px;
          //background-color: aquamarine;
          color: #c1bfbb;
          font-size: 25px;
        }
      }

      /deep/ .el-upload-dragger {
        width: 330px;
        background-color: #1d2027;
        border-color: #3e4149;
        height: 100%;
      }

      /deep/ .el-upload-dragger:hover {
        border-color: #5865f2;
        height: 100%;
      }

    }

    .options_item {
      margin: 10px 0 10px;
      .Generate_Background {
  display: flex;
  //justify-content: space-between;

  div {
    box-sizing: border-box;
    width: 75px;
    padding: 8px 0;
    text-align: center;
    border: 2px solid #1d2027;
    background-color: #1d2027;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
  }

  .background_item {
    border: 2px solid #5865f2;
  }

}

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }
  }

//提交按钮
  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;
      /deep/ .el-loading-mask {
        background: none;
      }

      &.disabled_btn {
        cursor: not-allowed;
        background-color: #393b3f;
        user-select: none;
        color: #999;
      }
    }

  }


}




/deep/ .el-loading-mask {
  background: none;
}
</style>